import React from 'react';

import styles from './Button.module.scss'
import Loader from '../Loader/Loader';

const Button = ({onClick = () => {}, className = '', children, small = false, loading = false, secondary = false}) => {
    const handleClick = () => {
        if (loading) {
            return;
        }

        return onClick();
    }
    return (
        <button className={`${styles.button} ${secondary && styles.secondary} ${small && styles.small} ${className}`} onClick={handleClick}>
            {loading ? <Loader size={14} /> : undefined}
            <span className={`${styles.innerContainer} ${loading ? styles.loading : ''}`}>{children}</span>
        </button>
    )
}

export default Button;